// extracted by mini-css-extract-plugin
export default {"notification-dot-container":"NotificationDot_notification-dot-container__1P8yv","notification-dot":"NotificationDot_notification-dot__rVdYi"};